import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { useInstance } from 'intact-vue-next';
import { Option } from './option';
import { OptionGroup } from './group';
import { eachChildren, isComponentVNode } from '../utils';
import { useState } from '../../hooks/useState';
export function useImmutable() {
  var instance = useInstance();
  var immutableValues = useState([]);
  function setImmutableValues() {
    var _instance$get = instance.get(),
      children = _instance$get.children,
      multiple = _instance$get.multiple;
    if (!multiple) return;
    updateImmutableValues(children);
  }
  function updateImmutableValues(children) {
    var _immutableValues = [];
    var loop = function loop(children) {
      eachChildren(children, function (vNode) {
        if (isComponentVNode(vNode, Option)) {
          var _vNode$props = vNode.props,
            disabled = _vNode$props.disabled,
            value = _vNode$props.value;
          if (disabled) {
            _immutableValues.push(value);
          }
        } else if (isComponentVNode(vNode, OptionGroup)) {
          loop(vNode.props.children);
        }
      });
    };
    loop(children);
    immutableValues.set(_immutableValues);
  }
  function isClosable(key) {
    var _context;
    return !_includesInstanceProperty(_context = immutableValues.value).call(_context, key);
  }
  instance.on('$receive:children', setImmutableValues);
  return {
    immutableValues: immutableValues,
    isClosable: isClosable
  };
}